/**
 * "Add MyDeck to your Home Screen" — for an iPhone in Safari, not yet
 * installed (mobile M5). Safari offers no install prompt, so the steps are
 * given in words, and only to the people they apply to. Installed, MyDeck
 * opens full screen, works with no signal and can receive notifications.
 */

import { Share, SquarePlus } from "lucide-react";

import { Panel } from "@/components/ui/primitives";
import { isInstalledPWA, isIOSSafari } from "@/platform";

export function InstallHint() {
  if (!isIOSSafari() || isInstalledPWA()) return null;
  return (
    <Panel className="p-5">
      <h2 className="font-display text-base font-medium text-ink">Put MyDeck on your Home Screen</h2>
      <p className="mt-1 text-sm text-muted">
        It then opens full screen, shows your last figures with no signal, and can send you notifications.
      </p>
      <ol className="mt-3 space-y-2 text-sm text-ink">
        <li className="flex items-center gap-2">
          <span className="font-mono text-xs text-faint">1</span>
          Tap <Share className="h-4 w-4 text-brass" aria-label="Share" /> at the bottom of Safari.
        </li>
        <li className="flex items-center gap-2">
          <span className="font-mono text-xs text-faint">2</span>
          Choose <SquarePlus className="h-4 w-4 text-brass" aria-hidden /> <b className="font-medium">Add to Home Screen</b>.
        </li>
        <li className="flex items-center gap-2">
          <span className="font-mono text-xs text-faint">3</span>
          Open MyDeck from the new icon. If it asks, sign in once more.
        </li>
      </ol>
    </Panel>
  );
}
